export const styles = {
    interText: {
        fontFamily: 'Inter, sans-serif'
    },
    interCenter: {
        fontFamily: 'Inter, sans-serif',
        textAlign: 'center'
    },
    robotoText: {
        fontFamily: 'Roboto, sans-serif'
    },
    robotoCenter: {
        fontFamily: 'Roboto, sans-serif',
        textAlign: 'center'
    }
};